<template>
	<section v-loading="loadingDM">
		<div class="operator">
			<div class="operator-col">
				<enum-filter
					size="mini"
					v-model="filterStatus.index"
					placeholder="中签"
					suffix-icon="el-icon-caret-bottom"
					clearable
					data-model-name="Book_item"
					field="status"
				></enum-filter>
			</div>
			<div class="operator-col">
				<div class="operator-col">
					<store-input v-model="filterStore"></store-input>
				</div>
			</div>
			<div class="operator-col">
				<list-filter
					size="mini"
					v-model="filterColor"
					placeholder="颜色"
					suffix-icon="el-icon-caret-bottom"
					clearable
					:list="value.colores"
					data-model-name="Book_item"
					field="color"
				></list-filter>
			</div>
			<div class="operator-col">
				<list-filter
					size="mini"
					v-model="filterModel"
					placeholder="尺码"
					suffix-icon="el-icon-caret-bottom"
					clearable
					:list="value.models"
					data-model-name="Book_item"
					field="model"
				></list-filter>
			</div>
			<div class="operator-col">
				<el-input
					size="mini"
					v-model="filterTableSearch"
					placeholder="姓名/手机号"
					suffix-icon="el-icon-search"
					clearable
				></el-input>
			</div>
			<div class="operator-col">
				<el-button size="mini" type="primary" @click="doExport(itemDataModel)">导出</el-button>
			</div>
		</div>
		<sum-table
			ref="sumTable"
			:data-model="itemDataModel"
			:search-filter="filterTableSearch"
			:kv-filter="kvFilter"
			:fields="sumFields"
		></sum-table>
		<curd-table
			ref="listTable"
			:data-model="itemDataModel"
			:fields="tableFields"
			:kv-filter="kvFilter"
			:search-filter="filterTableSearch"
			:isFieldChooseble="true"
			:expand-fields="beExpandFields"
			@doedit="handleEdit($event)"
			:hasDelete="false"
		></curd-table>
		<editor
			:show.sync="editorVisible"
			:data-model-name="itemDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import LoadDM from "@/mixins/LoadDM.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import FilterStatus from "@/mixins/Filter/FilterStatus.js";
import FilterColor from "@/mixins/Filter/FilterColor.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";
import FilterStore from "@/mixins/Filter/FilterStore.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, LoadDM, Filters, FilterStatus, FilterStore, FilterColor, FilterModel],
	data() {
		return {
			items: [],
			itemDataModel: "Book_item",
			beExpandFields: [
				{
					name: "vouchers",
					sortable: "custom",
				},
			],
			sumFields: [
				{
					name: "count",
					title: "数量(笔)",
				},
			],
			tableFields: [
				{
					name: "name",
				},
				{
					name: "phone",
				},
				{
					name: "cardid",
				},
				{
					name: "color",
					sortable: "custom",
				},
				{
					name: "model",
					sortable: "custom",
				},
				{
					name: "store",
					sortable: "custom",
				},
				{
					name: "status",
					sortable: "custom",
				},
				{
					name: "created_at",
					sortable: "custom",
				},
				{
					name: "he_must_win",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "name",
					isOnlyShow: true,
				},
				{
					name: "active",
					sortable: "custom",
					isOnlyShow: true,
				},
				{
					name: "he_must_win",
					sortable: "custom",
				},
			],
		};
	},
	props: {
		recordId: {
			type: String,
			default: "",
		},
		value: {
			type: Object,
			default: null,
		},
	},
	computed: {
		...mapState(["storeMapping", "userPrivilegeMapping"]),
	},
	methods: {},
	mounted() {
		this.baseKv.push({ k: "active", t: "id", v: this.recordId, lge: "==" });
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
.expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.cell {
	.el-button {
		margin-bottom: 1em;
	}
}
</style>
